import classNames from 'classnames'
import { useState } from 'react'
import { useField } from 'remix-validated-form'
import FormInputWrapper, { BaseInputClasses, FormInputWrapperProps } from './FormInputWrapper'

export type FormTextAreaInputProps = {
  rows?: number
  readOnly?: boolean
  readOnlyAsLabel?: boolean
  labelClassName?: string
  errorClassName?: string
} & FormInputWrapperProps<HTMLTextAreaElement>

export default function FormTextArea({
  name,
  label,
  placeholder,
  readOnly,
  cols,
  rows = 6,
  readOnlyAsLabel,
  className,
  wrapperClassName,
  labelClassName,
  errorClassName,
  showErrorIcon,
  newLineError,
  onChange,
  ...props
}: FormTextAreaInputProps) {
  const { error, getInputProps, validate } = useField(name)
  const [textLength, setTextLength] = useState<number>(props.defaultValue?.toString().length || 0)
  const inputClasses = classNames(
    className,
    BaseInputClasses,
    readOnly &&
      (readOnlyAsLabel
        ? `border-trn-200 shadow-elevation-1 read-only:cursor-not-allowed read-only:border-none read-only:p-0 read-only:shadow-none read-only:text-trn-500 read-only:focus:text-trn-500`
        : `border-trn-200 shadow-elevation-1 read-only:cursor-not-allowed read-only:border-gray-200 read-only:bg-trn-100 read-only:text-trn-500 read-only:focus:text-trn-500`),
  )

  return (
    <>
      <FormInputWrapper
        {...{
          name,
          label,
          error,
          showErrorIcon,
          cols,
          newLineError,
          wrapperClassName,
          className: labelClassName ?? `text-ui-sm`,
          errorClassName,
          defaultValue: props.defaultValue,
        }}
      >
        <div className="relative">
          <textarea
            rows={rows}
            defaultValue={props.defaultValue}
            {...getInputProps({ ...props, placeholder, readOnly: readOnly })}
            className={classNames(inputClasses, `py-4`)}
            onChange={(e) => {
              setTextLength(e.target.value.length)
              onChange?.(e)
            }}
            onInput={() => {
              // this triggers a validation on input, it allows to update error status on the fly
              validate()
            }}
          />
          {props.maxLength && <span className="text-body-sm text-trn-400">{`${textLength}/${props.maxLength}`}</span>}
        </div>
      </FormInputWrapper>
    </>
  )
}
